"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopPageSubscriptionEntries = ShopPageSubscriptionEntries;
const react_i18next_1 = require("react-i18next");
const react_1 = __importDefault(require("react"));
const shop_page_subscription_entry_list_1 = require("./shop-page-subscription-entry-list");
function ShopPageSubscriptionEntries({ loyaltyOrder, loyaltyCount }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(shop_page_subscription_entry_list_1.ShopPageSubscriptionEntryList, { entries: loyaltyOrder.entries, loyaltyCount: loyaltyCount }),
        react_1.default.createElement("br", null),
        react_1.default.createElement("div", { className: "loyalties__orders-box-results-product-details-order" },
            react_1.default.createElement("div", { className: "loyalties__orders-box-results-product-details-order-total loyalty-price-pv" },
                react_1.default.createElement("div", { className: "subscription_total_price" }, t("label.order.details.total")),
                react_1.default.createElement("div", { className: "subscription_total_price" },
                    react_1.default.createElement("span", { className: "subscription_total_price_pv_color" },
                        loyaltyOrder.totalPV,
                        t("text.product.pv")),
                    "\u00A0",
                    loyaltyOrder.totalPriceWithTax.formattedValue))));
}
